"use client";
import React, { useState, useRef, useEffect,useMemo } from "react";
import styles from "./Footer.module.css"
import plusBtn from "@/assets/Icon/Plus_Icon.png"
import   { useTranslation } from "react-i18next";
import dynamic from "next/dynamic";
const FamilySite = dynamic(() => import('@/Component/FamilySite'), { ssr: false });


import { useRouter } from 'next/navigation'; 
import logo_Image from "@/assets/logo/BePex_Logo.webp"
import { OnOpenUrl,OnPreFetchUrl } from "./accordion";
import Image from "next/image";
import i18n from "i18next";
export const textData = [
    {
        nameKey: "Footer.CustomerCenter",
        url: "service/center"
    },
    {
        nameKey: "Footer.SiteMap",
        url: "service/site-map"
    },
    {
        nameKey: "Footer.PersonalPolicy",
        url: "service/privacy-policy"
    },
    {
        nameKey: "Footer.InfoPolicy",
        url: "service/termsof-service"
    }
];
const Footer = () => {
    const { t } = useTranslation();
        const router = useRouter();
    
    const [isVisible, setIsVisible] = useState(false); // 렌더링 여부
    const [isOpen, setIsOpen] = useState(false);       // 애니메이션 상태
    const familyRef = useRef(null);
    const [panelWidth, setPanelWidth] = useState(0);
    const toggleFamilyPanel = () => {
        if (isVisible) {
          setIsOpen(false);
          setTimeout(() => setIsVisible(false), 300);
        } else {
          // 1. 먼저 열리는 상태부터 true로 설정
          setIsOpen(true);
      
          // 2. 살짝 delay 주고 렌더링
          setTimeout(() => setIsVisible(true), 10);
        }
      };
      useEffect(() => {
        if (familyRef.current) {
            setPanelWidth(familyRef.current.offsetWidth)
        const handleClickOutside = (event) => {
          if (familyRef.current && !familyRef.current.contains(event.target)) {
            setIsOpen(false);
            setTimeout(() => setIsVisible(false), 300);
          }
        };
      
        if (isVisible) {
          document.addEventListener("mousedown", handleClickOutside);
        }
      
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
    };
      }, [isVisible]);
      useEffect(() => {
        footerTexts.map((item, index) => {
            OnPreFetchUrl({content: item,navigate:router});
        });

      },[]);

      const footerTexts = useMemo(() => {
        return textData.map((label) => ({
          ...label,
          text: t(label.nameKey),
        }));
      }, [t, i18n.language]); // t도 종속성으로 포함
      
    return (
        <footer className={styles.footer}>
            <div className={styles.footer__container}>
                <div className={styles.footer__top}>
                    <div className={styles.footer__familysite} ref = {familyRef}onClick={toggleFamilyPanel} >
                        <div className={styles.footer__family__text}>
                            <span>
                                {t("Footer.Family")}
                            </span>
                        </div>
                        <div className={styles.footer__plus__btn}>
                            <Image src={plusBtn} className={styles.footer__plus__btn__image} alt="family site">
                            </Image>
                        </div>
                        {isVisible && <FamilySite isOpen={isOpen}  width={panelWidth}/>}
                    </div>
                    <div className={styles.footer__menu}>
                        {footerTexts.map((label, index) => (
                            <span key={index} className={styles.footer__menu__text} onClick={() => OnOpenUrl({content : label, navigate : router})}>
                                {label.text}
                            </span>
                        ))}

                    </div>
                </div>

                <div className={styles.footer__copyinfo}>
                    <div className={styles.footer__logo}>
                        <Image className={styles.footer__logo__image} src={logo_Image} alt="logo">
                        </Image>
                    </div>

                    <div className={styles.footer__copyright__text}>
                        <span>
                            Copyright©BePex. All Rights Reserved.
                        </span>
                    </div>
                </div>

            </div>

        </footer>
    )
}

export default Footer;